// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'HelveticaNowText', 'HelveticaNowText Fallback'"},"className":"__className_9731cc","variable":"__variable_9731cc"};